import { ExpandIcon, Flex, IconButton, ShrinkIcon, SyncAltIcon, Text, useMatchBreakpoints } from '@pancakeswap/uikit'
import { CurrencyLogo, DoubleCurrencyLogo } from 'components/Logo'
import BasicChart from './BasicChart'
import { StyledPriceChart } from './styles'

const PriceChart = ({
  inputCurrency,
  outputCurrency,
  onSwitchTokens,
  isDark,
  isChartExpanded,
  setIsChartExpanded,
  isMobile,
  isFullWidthContainer,
  token0Address,
  token1Address,
  currentSwapPrice,
}) => {
  const toggleExpanded = () => setIsChartExpanded((currentIsExpanded) => !currentIsExpanded)

  return (
    <StyledPriceChart
      height="70%"
      overflow="unset"
      $isDark={isDark}
      $isExpanded={isChartExpanded}
      $isFullWidthContainer={isFullWidthContainer}
    >
      <Flex justifyContent="space-between" px={isMobile ? '16px' : '24px'}>
        <Flex alignItems="center">
          <div
            style={{
              marginRight: 12,
            }}
          >
            {outputCurrency ? (
              <DoubleCurrencyLogo currency0={inputCurrency} currency1={outputCurrency} size={36} />
            ) : (
              inputCurrency && <CurrencyLogo currency={inputCurrency} size="36px" />
            )}
          </div>
          {inputCurrency && (
            <Text className="text-token" color="text" bold>
              {outputCurrency ? `${inputCurrency.symbol}/${outputCurrency.symbol}` : inputCurrency.symbol}
            </Text>
          )}
          <IconButton variant="text" onClick={onSwitchTokens}>
            <img src="/images/swap/swap1.svg" alt="sync" />
          </IconButton>
        </Flex>
        {!isMobile && (
          <Flex>
            <IconButton variant="text" onClick={toggleExpanded}>
              {isChartExpanded ? (
                <ShrinkIcon color="rgba(255, 255, 255, 0.6)" />
              ) : (
                <img alt="shrink" src="images/swap/shrink.svg" />
              )}
            </IconButton>
          </Flex>
        )}
      </Flex>
      <BasicChart
        token0Address={token0Address}
        token1Address={token1Address}
        isChartExpanded={isChartExpanded}
        inputCurrency={inputCurrency}
        outputCurrency={outputCurrency}
        isMobile={isMobile}
        currentSwapPrice={currentSwapPrice}
      />
    </StyledPriceChart>
  )
}

export default PriceChart
